var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container section"},[_c('hr'),_c('div',{staticClass:"row"},[_c('h3',{staticClass:"indigo-text text-darken-4"},[_vm._v(_vm._s(_vm.day))]),_c('plan-tabs',{attrs:{"id":_vm.id,"day":_vm.day}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }